const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

export const getAllProspects = () =>
  request('/prospects');

export const getProspectStats = () =>
  request('/prospects/stats');

export const getProspectJourney = (id) =>
  request(`/prospects/${id}/journey`);

export const tickMilestone = (id, stageKey, milestoneKey, checked, notes) =>
  request(`/prospects/${id}/stages/${stageKey}/milestones/${milestoneKey}`, {
    method: 'PUT',
    body: JSON.stringify({ checked, notes })
  });

export const addRevision = (id, stageKey, milestoneKey, notes) =>
  request(`/prospects/${id}/stages/${stageKey}/milestones/${milestoneKey}/revision`, {
    method: 'POST',
    body: JSON.stringify({ notes })
  });

export const updateDocumentItem = (id, docKey, status, notes, isNotApplicable) =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}`, {
    method: 'PUT',
    body: JSON.stringify({ status, notes, isNotApplicable })
  });

export const logTouchpoint = (id, type, outcome, notes, durationMinutes, touchedAt, nextFollowUpAt, loggedByUserId) =>
  request(`/prospects/${id}/touchpoints`, {
    method: 'POST',
    body: JSON.stringify({ type, outcome, notes, durationMinutes, touchedAt, nextFollowUpAt, loggedByUserId })
  });

export const completeExecution = (id) =>
  request(`/prospects/${id}/complete-execution`, { method: 'POST' });

export const logMeeting = (id, stageKey, body) =>
  request(`/prospects/${id}/stages/${stageKey}/meetings`, {
    method: 'POST',
    body: JSON.stringify(body)
  });

export const updateStageNotes = (id, stageKey, notes) =>
  request(`/prospects/${id}/stages/${stageKey}/notes`, {
    method: 'PUT',
    body: JSON.stringify({ notes })
  });

export const toggleProposedDoc = (id, docKey, selected, notes) =>
  request(`/prospects/${id}/stages/INITIAL_REVIEW_DISCUSSION/proposed-docs/${docKey}`, {
    method: 'PUT',
    body: JSON.stringify({ selected, notes })
  });

export const uploadMilestoneFile = (id, stageKey, milestoneKey, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request(`/prospects/${id}/stages/${stageKey}/milestones/${milestoneKey}/files`, {
    method: 'POST',
    headers: {},
    body: formData
  });
};

export const deleteMilestoneFile = (id, stageKey, milestoneKey, fileId) =>
  request(`/prospects/${id}/stages/${stageKey}/milestones/${milestoneKey}/files/${fileId}`, {
    method: 'DELETE'
  });

export const getMilestoneFileLink = (id, stageKey, milestoneKey, fileId) =>
  request(`/prospects/${id}/stages/${stageKey}/milestones/${milestoneKey}/files/${fileId}/open`);

export const requestDocument = (id, docKey, requestedBy = 'system') =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/request`, {
    method: 'POST',
    body: JSON.stringify({ requested_by: requestedBy })
  });

export const uploadDocumentFile = (id, docKey, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/files`, {
    method: 'POST',
    headers: {},
    body: formData
  });
};

export const deleteDocumentFile = (id, docKey, fileId) =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/files/${fileId}`, {
    method: 'DELETE'
  });

export const getDocumentFileLink = (id, docKey, fileId) =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/files/${fileId}/open`);

export const acceptDocument = (id, docKey, acceptedBy = 'system') =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/accept`, {
    method: 'POST',
    body: JSON.stringify({ accepted_by: acceptedBy })
  });

export const rejectDocument = (id, docKey, reason, rejectedBy = 'system') =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/reject`, {
    method: 'POST',
    body: JSON.stringify({ reason, rejected_by: rejectedBy })
  });

export const processDocument = (id, docKey, processedBy = 'system') =>
  request(`/prospects/${id}/stages/DOCUMENT_COLLECTION/documents/${docKey}/process`, {
    method: 'POST',
    body: JSON.stringify({ processed_by: processedBy })
  });
